// ** React Imports
import { useEffect } from 'react'
import { NavLink } from 'reactstrap'

// ** Icons Imports
import { Circle, Disc } from 'react-feather'

// ** Config
import { useSkin } from '@hooks/useSkin'

// ** Utils
import { getUserData } from '@utils'
import { DefaultRoute } from '../../../../../router/routes'

const image1 = require('@src/assets/images/logo/leave-lg-2.png').default
const image2 = require('@src/assets/images/logo/leave-lg-2-dark.png').default

const image1_small = require('@src/assets/images/logo/leave-sm.png').default
const image2_small = require('@src/assets/images/logo/leave-sm.png').default

const VerticalMenuHeader = (props) => {
  // ** Props
  const { menuCollapsed, setMenuCollapsed, setMenuVisibility, setGroupOpen, menuHover } = props

  // ** Vars
  const user = getUserData()
  const { skin } = useSkin()

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([])
  }, [menuHover, menuCollapsed])

  return (
    <>
      <div className="navbar-header p-0">
        <ul className="nav navbar-nav flex-row">
          <li className="nav-item me-auto">
            <NavLink href={DefaultRoute} className="navbar-brand">
              <span className="brand-logo">
                {!menuCollapsed || menuHover ? (
                  <img src={skin === 'dark' ? image2 : image1} alt="logo" />
                ) : (
                  <img
                    className="img-fluid"
                    style={{ objectFit: 'fill', transform: 'scale(0.8)', marginLeft: '-5px' }}
                    src={skin === 'dark' ? image2_small : image1_small}
                    alt="logo"
                  />
                )}
              </span>
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  )
}

export default VerticalMenuHeader
